import { useId } from 'react';
import S from './SelectStyles';

type Option = {
  label: string,
  value: string | number,
  hidden?: boolean,
};

type Props = {
  name?: string;
  label?: string;
  placeholder?: string;
  options: Option[];
  onChange?: any;
  onBlur?: any;
  value: string;
  styleWrapper?: Record<string, string>;
  size?: number;
  disabled?: boolean;
  error?: string;
  simple?: boolean;
};

function Select({
  name,
  label,
  placeholder,
  options,
  onChange,
  onBlur,
  value,
  styleWrapper,
  size,
  disabled,
  error,
  simple,
}: Props): JSX.Element {
  const id = useId();
  return simple ? (
    <S.SimpleWrapper
      style={styleWrapper}
    >
      <select
        id={id}
        name={name}
        placeholder={placeholder}
        onChange={onChange}
        onBlur={onBlur}
        value={value}
        size={size}
        disabled={disabled}
      >

        {
          // eslint-disable-next-line arrow-body-style
          !!options.length && options.map((o, i) => {
            return o.hidden ? (
              // eslint-disable-next-line react/no-array-index-key
              <option value={o.value} key={`${id}${i}`} hidden>{o.label}</option>
            ) : (
              // eslint-disable-next-line react/no-array-index-key
              <option value={o.value} key={`${id}${i}`}>{o.label}</option>
            );
          })
        }
      </select>
    </S.SimpleWrapper>
  ) : (
    <S.Wrapper
      style={styleWrapper}
      error={!!error}
    >
      {!!label && (
        <label htmlFor={id}> {label} </label>
      )}
      <select
        id={id}
        name={name}
        placeholder={placeholder}
        onChange={onChange}
        onBlur={onBlur}
        value={value}
        size={size}
        disabled={disabled}
      >
        {!!options.length && options.map((o, i) => (
          // eslint-disable-next-line react/no-array-index-key
          <option value={o.value} key={`${id}${i}`}>{o.label}</option>
        ))}
      </select>
      {!!error && (
        <S.ErrorMessage> {error} </S.ErrorMessage>
      )}
    </S.Wrapper>
  );
}

export default Select;
